import { render, staticRenderFns } from "./TiktokStores.vue?vue&type=template&id=097e950a&scoped=true"
import script from "./TiktokStores.vue?vue&type=script&lang=js"
export * from "./TiktokStores.vue?vue&type=script&lang=js"
import style0 from "./TiktokStores.vue?vue&type=style&index=0&id=097e950a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097e950a",
  null
  
)

export default component.exports